import { render } from "./DashboardModal.vue?vue&type=template&id=6ce77aca&scoped=true&ts=true"
import script from "./DashboardModal.vue?vue&type=script&lang=ts"
export * from "./DashboardModal.vue?vue&type=script&lang=ts"

import "./DashboardModal.vue?vue&type=style&index=0&id=6ce77aca&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce77aca"]])

export default __exports__